 import * as React from 'react';
 import VirtualizedSelect from 'react-virtualized-select';
 import axios from 'axios';
 import {apiUrl} from './UrlParam'; 

export class DialogFormTemplate extends React.Component {
    //priorityData = DataUtil.distinct(orderData, 'priority', true);
    constructor(props) {
        super(props);
        console.log(props)
        //this.state = Object.assign({}, props[0]);
        this.state = {
            data :  Object.assign({}, props[0]),
            unitList: [],
            productTypeList :[{
                label : "None",
                value : 0
            },{
                label : "Material",
                value : 1
            },{
                label : "Service",
                value : 2
            }],
            
          };
    }

    componentDidMount() {
        axios.get(`${apiUrl}/api/GetUnits`)
            .then((response) => {
                const transformedOptions = response.data.map((item) => ({
                    label: `${item.name}`,
                    value: item.id,
            }));
        this.setState({unitList : transformedOptions});
        //this.setState({data : {product_type :{ label : "Material", value :1 }}});
    
    })
    .catch((error) => {
      console.error('Error fetching category data:', error);
    });
    }

     
    onChange(args) {
       //console.log(args.target.name)
        this.setState({data :{ [args.target.name]: args.target.value }});
    }

    onChange2(args) {
        this.setState({data : {product_type :{ label : args.label, value :args.value }}});
    }

    // onChange2(args) {
    //    // console.log(args.label)
    //     this.setState({data :{ ['unit_name']: args.label }});
    // }
    
    render() {
        this.onChange = this.onChange.bind(this);
        this.onChange2 = this.onChange2.bind(this);

        const data = this.state.data;

        return (
        
        <div style={{width:800}}>
            <div className="form-row">
            <div className="form-group col-md-6"  style={{display:"none"}} >
                <div className="e-float-input e-control-wrapper"  >
                        <input id="code" name="code"  disabled={true} type="text" value={data.rev} onChange={this.onChange}/>
                        <span className="e-float-line"/>
                        <label className="e-float-text e-label-top"> rev</label>
                    </div>

                </div>
            <div className="form-group col-md-6"  style={{display:"none"}} >
                <div className="e-float-input e-control-wrapper"  >
                        <input id="code" name="code"  disabled={true} type="text" value={data.code} onChange={this.onChange}/>
                        <span className="e-float-line"/>
                        <label className="e-float-text e-label-top"> code</label>
                    </div>

                </div>

                <div className="form-group col-md-6" style={{display:"none"}} >
                <div className="e-float-input e-control-wrapper"  >
                        <input id="invoice_id" name="invoice_id"  disabled={true} type="text" value={data.invoice_id} onChange={this.onChange}/>
                        <span className="e-float-line"/>
                        <label className="e-float-text e-label-top"> ID</label>
                    </div>

                </div>
                <div className="form-group col-md-6">
                <div className="e-float-input e-control-wrapper">
                        <input id="part_no" name="part_no" type="text"   value={data.part_no} onChange={this.onChange}/>
                        <span className="e-float-line"/>
                        <label className="e-float-text e-label-top">Part No</label>
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-md-6">
                <div className="e-float-input e-control-wrapper">
                        {/* <input id="descriptions" name="descriptions"  type="text" value={data.descriptions} onChange={this.onChange}/> */}
                        <textarea id="descriptions" name="descriptions"   rows={3} value={data.descriptions} onChange={this.onChange}/>
                        <span className="e-float-line"/>
                        <label className="e-float-text e-label-top">Description</label>
                    </div>

                </div>
              
            </div>
            <div className="form-row">
                <div className="form-group col-md-6">
                <div className="e-float-input e-control-wrapper">
                        <input id="newqty" name="newqty" disabled={false}  type="number" max={100} min={0}  value={data.newqty} onChange={this.onChange}/>
                        <span className="e-float-line"/>
                        <label className="e-float-text e-label-top">Qty</label>
                    </div>

                </div>
                <div className="form-group col-md-6">
                <div className="e-float-input e-control-wrapper">
                        <input id="price" name="price" type="number"  min={0} disabled={false} value={data.price} onChange={this.onChange}/>
                        <span className="e-float-line"/>
                        <label className="e-float-text e-label-top">Price</label>
                    </div>
                </div>
            </div>

            <div className="form-row">
                <div className="form-group col-md-6">
                <div className="e-float-input e-control-wrapper">
                <input id="unit_name" name="unit_name" type="text"  min={0}  value={data.unit_name} onChange={this.onChange}/>
                {/* <VirtualizedSelect
                                options={this.state.unitList}
                                onChange={this.onChange2}
                                value={data.unit_name}
                                clearable={false}
                                searchable={true}
                                id="unit_name"
                                name="unit_name"
                             //   disabled={product.isChecked}
                                
                                
                            />  */}
                        <span className="e-float-line"/>
                        <label className="e-float-text e-label-top">Unit</label>
                    </div>

                </div>
                <div className="form-group col-md-6">
                <div className="e-float-input e-control-wrapper">
                 
                 <div style={{marginTop:25}}>
                    
                     <VirtualizedSelect
                                options={this.state.productTypeList}
                                onChange={this.onChange2}
                                value={data.product_type}
                                clearable={false}
                                searchable={true}
                                id="product_type"
                                name="product_type"
                                style={{borderTop:0,borderLeft:0,borderRight:0}}
                                required
                             //   disabled={product.isChecked}
                                
                                
                            /> 
                            <label className="e-float-text e-label-top" >Product Type</label> 
                 </div>
               
                       
                 
                    </div>

                </div>
            </div>
        </div>);
    }
}